// extracted by mini-css-extract-plugin
export default {"main":"GeneratedAssetDetail_main__v12SD","rows_1":"GeneratedAssetDetail_rows_1__R3tqq","rows_2":"GeneratedAssetDetail_rows_2__BdZJM","rows_3":"GeneratedAssetDetail_rows_3__+sali"};